import { useEffect, useState, useRef } from "react"
import { useGetExercisetypesQuery, useUpdateExercisetypeMutation, useAddNewExercisetypeMutation } from './exercisetypesApiSlice'
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { toast } from 'react-toastify'
import useAuth from '../../hooks/useAuth'
import Exercisetype from "./Exercisetype"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave } from "@fortawesome/free-solid-svg-icons"

const ExercisetypesList = () => {

	useTitle('DPE: Exercise Types')

	const { isAdmin } = useAuth()

	const closeRef = useRef();

	// state for Exercisetype info
	const [currentExercisetypeId, setcurrentExercisetypeId] = useState('')
	const [currentExercisetype, setcurrentExercisetype] = useState('')

	const onExercisetypeChanged = e => setcurrentExercisetype(e.target.value)
	const onExercisetypeIdChanged = e => setcurrentExercisetypeId(e.target.value)

	const handleExercisetypeChange = (id, part) => {
		setcurrentExercisetype(part)
		setcurrentExercisetypeId(id)
	};

	// load exercise types
	const {
		data: exercisetypes,
		isLoading,
		isSuccess,
		isError,
		error
	} = useGetExercisetypesQuery('exercisetypesList')

	useEffect(() => {

		if (isError) {
			toast.error(error?.data?.message);
		}

	}, [isError, error])


	// update Exercisetype
	const [updateExercisetype, {
		isSuccess: isUpdateSuccess,
		isError: isUpdateError,
		error: errorUpdate
	}] = useUpdateExercisetypeMutation()

	useEffect(() => {

		if (isUpdateSuccess) {
			setcurrentExercisetypeId('')
			setcurrentExercisetype('')
			closeRef.current.click()
			toast.success("Exercisetype was Updated");
		}

		if (isUpdateError) {
			toast.error(errorUpdate?.data?.message);
		}

	}, [isUpdateSuccess, isUpdateError, errorUpdate])


	// add Exercisetype
	const [addExercisetype, {
		isSuccess: isAddSuccess,
		isError: isAddError,
		error: errorAdd
	}] = useAddNewExercisetypeMutation()

	useEffect(() => {
		if (isAddSuccess) {
			setcurrentExercisetypeId('')
			setcurrentExercisetype('')
			closeRef.current.click()
			toast.success("Exercisetype was Added");
		}
		if (isAddError) {
			toast.error(errorAdd?.data?.message);
		}
	}, [isAddSuccess, isAddError, errorAdd])


	// Add or Update Exercisetype
	const onSaveExercisetypeClicked = async (e) => {
		if (currentExercisetypeId === '') {
			await addExercisetype({ exercisetype: currentExercisetype })
		} else {
			await updateExercisetype({ id: currentExercisetypeId, exercisetype: currentExercisetype })
		}
	}


	// pagination: 1
	const [currentPage, setcurrentPage] = useState(1)
	const [itemsPerPage, setitemsPerPage] = useState(3)
    const updateitemsPerPage = (e) => {
        setitemsPerPage(e.target.value)
        setcurrentPage(1)
    }
	const pageSizes = [3, 6, 9, 12, 15];



	let content

	if (isLoading) content = <PulseLoader color={"#5f788a"} />

	if (isSuccess) {

		if (!isAdmin) {
			return toast.error('Not Authorized');
		}

		const { ids } = exercisetypes

		// pagination: 2
		const totalItems = ids.length
		const lastIndex = currentPage * itemsPerPage
		const firstIndex = lastIndex - itemsPerPage
		const currentPageItems = ids.slice(firstIndex, lastIndex)
		let lastPage = Math.ceil(ids.length / itemsPerPage)
		const pages = []
		if (totalItems <= itemsPerPage) {
			let i = 1
			pages.push(i)
			lastPage = 1
		} else {
			for (let i = 1; i < lastPage + 1; i++) {
				pages.push(i)
			}
		}

		let tableContent = null
		tableContent = currentPageItems.map(exercisetypeId => <Exercisetype key={exercisetypeId} exercisetypeId={exercisetypeId} onExercisetypeChange={handleExercisetypeChange} />)


		content = (
			<section id="main_content">

				<div className="modal" id="modalExercisetype">
					<div className="modal-dialog modal-dialog-centered">
						<div className="modal-content">

							<div className="modal-header">
								<h4 className="modal-title">Edit Exercisetype</h4>
								<button type="button" className="btn-close" data-bs-dismiss="modal" ref={closeRef} ></button>
							</div>

							<div className="modal-body text-end">
								<form onSubmit={e => e.preventDefault()}>
									<input id="Exercisetype" className="form-control" value={currentExercisetype} onChange={onExercisetypeChanged} />
									<input id="Exercisetype_id" type="hidden" value={currentExercisetypeId} onChange={onExercisetypeIdChanged} />
									<br />
									<span
										role="button"
										className="text-success p-2 icon"
										title="Save"
										onClick={onSaveExercisetypeClicked}
									>
										Save Exercisetype
										<FontAwesomeIcon icon={faSave}  className="fa-icon" />
									</span>
								</form>
							</div>
						</div>
					</div>
				</div>

				<header>
					<div className="row">
						<div className="col-md-4">
							<h1 className="text-steel mt-5">Exercisetypes</h1>
						</div>
						<div className="col-md-2 text-end mt-3">
							{totalItems} total items
						</div>
					</div>
				</header>
				<main>
					<div className="row">
						<div className="col-md-6">
							<table className="table table-striped">
								<thead>
									<tr>
										<th>Exercisetype</th>
										<th>Edit</th>
									</tr>
								</thead>
								<tbody>
									{tableContent}
								</tbody>
							</table>
						</div>
					</div>

					<div className="row">
						<div className="col-md-2">
							<ul className="pagination">
								{
									pages.map((page, index) => {
										let clsName = currentPage - 1 === index ? 'page-item active' : "page-item"
										return (
											<li key={index} className={clsName}>
												<span className="page-link" role="button" onClick={() => setcurrentPage(page)}>{page}</span>
											</li>
										)
									})
								}
							</ul>


						</div>
						<div className="col-md-3 text-end mt-2">
							<label style={{marginRight:"10px"}}>Items per page</label>
						</div>
						<div className="col-md-1">
							<select name="itemsPerPage" id="itemsPerPage" className="form-control  text-end"
								value={itemsPerPage}
                                onChange={updateitemsPerPage}>
								{pageSizes.map((option, index) => {
									return (
										<option key={index}>
											{option}
										</option>
									);
								})}
							</select>
						</div>
					</div>

					<div className="row">
						<div className="col-md-6 text-end">
							<button className="btn btn-steel" data-bs-toggle="modal" data-bs-target="#modalExercisetype" >
								Add Exercisetype
							</button>
						</div>
					</div>
				</main>
			</section>



		)

		return content

	}


}

export default ExercisetypesList
